// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1CGOm","left":"InfoRow_left__2AXze"};